module.exports = __webpack_public_path__ + "static/media/menu_icon.960c3420.svg";